import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ThemePalette } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { BatchReportService } from 'src/app/services/batch-report-service';
import { ProductivityService } from 'src/app/services/productivity-service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Multilingual } from 'src/app/services/multilingual';
import * as moment from 'moment';
import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

@Component({
  selector: 'app-input-report',
  templateUrl: './input-report.component.html',
  styleUrls: ['./input-report.component.scss']
})
export class InputReportComponent implements OnInit {
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort  = new QueryList<MatSort>();
  @ViewChild('batchViewModal') private batchViewModal!: TemplateRef<any>;

  shiftList=[{
    value:'all',
    name:'ALL',
   
  },{
    value:'day',
    name:'Day',
  },{
    value:'night',
    name:'Night',
  }]
  
  public rowData!: any[];
  public columnDefs!: any[];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public defaultExportParams!:any;
  public defaultColDef!: any;
  public detailCellRendererParams!: any;
  public excelStyles!:any;
  Exdpandhide = true;
  Collapsehide = false;
  isCardExpanded = false;
  Isexpandcontentshow = true;
  Isexpandcontenthide = true;
  Isexpandcontentbuttonshow = false;
  gridOptions: any = {
    defaultColDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      flex: 1,
      filter : true,
      sortable: true,
      resizable: true,
      wrapText: true,     // <-- HERE
      autoHeight: true,   // <-- & HERE
      minWidth: 225,
    },
  };
  lang: any;
  languageDir = 'ltr';
  pageId: any;
  moduleId: any;
  langObj: any;
  constructor(
    private formBuilder: FormBuilder,
    private toaster: ToastrService,
    private userService: UserManagementService,
    private dialog: MatDialog,
    private productivityservice: ProductivityService,
    private enterpriseGroupService: EnterPriseGroupService,
    private batchReportService :BatchReportService,
    private translater: TranslaterService,
    private translate: TranslateService,
    public router: Router,
    private spinner: NgxSpinnerService
  ) { 
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();})
    // this.frameworkComponents = {
    //   buttonViewRenderer : ButtonViewRendererComponent,
    // }
    this.defaultExportParams = {
      getCustomContentBelowRow: function (params:any) {
        return [
          [
            cell('',''),
            cell('Machine', 'header'),
            cell('Item Code', 'header'),
            cell('Item Desc', 'header'),
            cell('Estimated Qt', 'header'),
            cell('UOM', 'header'),
            cell('Actual Qty', 'header'),
            cell('Created By', 'header'),
            cell('Created On', 'header')
          ],
        ].concat(
          params.node.data.productionItemBomList.map(function (record:any) {
            return [
              cell('',''),
              cell(record.PU_Desc, 'body'),
              cell(record.ItemCode, 'body'),
              cell(record.ItemDesc, 'body'),
              cell(record.EstimatedQty, 'body'),
              cell(record.UoM, 'body'),
              cell(record.Result, 'body'),
              cell(record.createdBy, 'body'),
              cell(record.createdOn, 'body')
            ];
          }),
          [[]]
        );
      },
      columnWidth: 120,
    };
    this.columnDefs = [
{headerName : 'Sr.No', field: 'SNo', valueGetter: "node.rowIndex + 1" ,cellRenderer: 'agGroupCellRenderer', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Item Code', field:'ItemCode', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Item Desc', field:'ItemDesc',resizable: true, wrapText: true, headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Estimated Qt', field:'EstimatedQty',valueFormatter: this.valueFormatter,precision: 3, headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'UOM', field:'UoM', headerValueGetter: this.localizeHeader.bind(this)},
{headerName : 'Actual Qty', field:'Result', valueFormatter: this.valueFormatter, precision: 3, headerValueGetter: this.localizeHeader.bind(this)},

    ];
    this.detailCellRendererParams = {
      detailGridOptions: {
        columnDefs: [
          {headerName : 'Machine', field:'PU_Desc', headerValueGetter: this.localizeHeader.bind(this)},
          {headerName : 'Item Code', field:'ItemCode', headerValueGetter: this.localizeHeader.bind(this)},
          {headerName : 'Item Desc', field:'ItemDesc',resizable: true, wrapText: true, headerValueGetter: this.localizeHeader.bind(this)},
          {headerName : 'Estimated Qt', field:'EstimatedQty',valueFormatter: this.valueFormatter,precision: 3, headerValueGetter: this.localizeHeader.bind(this)},
          {headerName : 'UOM', field:'UoM',headerValueGetter: this.localizeHeader.bind(this)},
          {headerName : 'Actual Qty', field:'Result', valueFormatter: this.valueFormatter, precision: 3, headerValueGetter: this.localizeHeader.bind(this)},
          {headerName : 'Created By', field:'createdBy', headerValueGetter: this.localizeHeader.bind(this)},
          {headerName : 'Created On', field:'createdOn',valueFormatter: function (params: any) { return moment(params.value).format('MM/DD/YYYY HH:mm') }, headerValueGetter: this.localizeHeader.bind(this)},
        ],
       defaultColDef: { flex: 1 },
      },
      getDetailRowData: function (params: any) {
      params.successCallback(params.data.productionItemBomList);
      },
    };
    this.excelStyles = [
      {
        id: 'header',
        interior: {
          color: '#a47ed9',
          pattern: 'Solid',
        },
      },
      {
        id: 'body',
        interior: {
          color: '#d1c1e8',
          pattern: 'Solid',
        },
      },
    ];
}

  // form unitDetailForm fields controls
  public disabled = true;
  public showSpinners = true;
  GroupList!: any[];
  PlantList1!: any[];
  lineList!: any[];
  unitList!: any[];
  itemList: any[] = new Array();
  filteredItemCodes!:any[];
  processOrderList!: any[];
  filteredPOs!:any[];

  batchReportViewDatasource!:  MatTableDataSource<any>;
  MachineId!: any;
  public showSeconds = false;
  public touchUi = false;
  public enableMeridian = false;
  public minDate: moment.Moment | undefined;
  public maxDate: moment.Moment | undefined;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  permisson!: any;
  IsAccess!: any;
  IsWrite!: any;
  breadcrumList!: any;
  isPopupMachine = false;
  prodDesc!: any;
  NB!:number;
  TEQ! : any;
  TAQ!:number;
  menuRedIconUrl = 'assets/images/menu-bottom-red-icon.png';
  menuGreenIconUrl = 'assets/images/menu-bottom-green-icon.png';

  public formGroup = new FormGroup({
    date: new FormControl(null, [Validators.required]),
  });

  batchViewColumns: any[] = [
    'itemtype',
    'itemDesc',
    'itemuom',
    'estQty',
    'actQty',
    'supplier',
    'prodDate',
    'expireDate'
  ];
  InputForm!: FormGroup;
  UnitNode: any;
  Group: string | undefined;
  length : boolean = false;
  inputReadonly = true;
  UnitName: string | undefined;
  isUnitName = false;
  ngOnInit(): void {
    this.GetBreadcrumList();
    this.GetMenuAccess();
    // // this.spinner.show(); 
    this.InputForm = this.formBuilder.group({
      UserGroup1: [],
      UserPlant1: [],
      startDate : [],
      endDate: [],
      line : [],
      unit:[],
      ItemCode: [],
      po: [],
      batchType :[],
      shift :[],
      queryCriteria :[],
    });

    this.datasource();
    this.InputForm.controls.line.valueChanges.subscribe((selectedValue: any) => {
      //this.getUnit(selectedValue);
    });

    this.InputForm.controls.UserPlant1.valueChanges.subscribe((value: any) => {
     // this.getLine(value);
    });

    this.InputForm.get('queryCriteria')?.patchValue('today');
    this.InputForm.get('shift')?.patchValue('all');
    this.InputForm.get('batchType')?.patchValue('0');
    const event = {
      value : 'today'
    }
    this.criteriaChange(event);  
  };

  ngAfterViewInit(): any {
  
  }

  onItemCodeChange(event : any):void { 
    //this.getProcessOrder(event.value);
  }

  onPOChange(event : any):void{
    this.itemList = [];
    this.filteredItemCodes = [];
    let item = this.processOrderList.find(element=> element.TypeId === event.value);
    this.itemList.push(item);
    this.filteredItemCodes = this.itemList.slice();
    this.InputForm.get('ItemCode')?.setValue(this.itemList[0].ItemCode);
  }


  datasource(): void {
    const key = {
      Id: 0
    };
    const id = {
      value: 0
    };
    this.productivityservice.getGroupData(key).subscribe((data: any) => {
      this.GroupList = data.lstEG;
      id.value = data.lstEG[0].EG_Id;
     //this.length = this.GroupList.length >=0 ? true : false;
      this.InputForm.get('UserGroup1')?.patchValue(data.lstEG[0].EG_Id);
      this.InputForm.get('UserPlant1')?.patchValue(data.lstEG[0].EG_Id);
      this.getPlants(id);
    }, (error: any) => {
      this.toaster.error('error', error.message);
    });
  }

  onSubmit(): void {
   this.spinner.show();
   this.getBatchReport();
  }


  criteriaChange(event:any):void {
    let startDate = new Date();
    let endDate = new Date();
    if(event.value === 'lastshift'){
      startDate.setDate(startDate.getDate() -1);
      startDate.setHours(19);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(7);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      this.InputForm.get('startDate')?.patchValue(startDate);
      this.InputForm.get('endDate')?.patchValue(endDate);
      this.disabled = true;
    }else if(event.value === 'yesterday'){
      startDate.setDate(startDate.getDate() -1);
      startDate.setHours(7);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(7);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      this.InputForm.get('startDate')?.patchValue(startDate);
      this.InputForm.get('endDate')?.patchValue(endDate);
      this.disabled = true;
    }else if(event.value === 'today'){
      startDate.setHours(7);
      startDate.setMinutes(0);
      startDate.setSeconds(0);
      endDate.setHours(19);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      this.InputForm.get('startDate')?.patchValue(startDate);
      this.InputForm.get('endDate')?.patchValue(endDate);
      this.disabled = true;
    }else{
      this.disabled = false;
      this.InputForm.get('startDate')?.patchValue(startDate);
      this.InputForm.get('endDate')?.patchValue(endDate);
    }
  }

  getPlants(event: any): void {
    const key = {
      EG_ID: event.value,
      userId: 206
    };

    this.productivityservice.getPlantsData(key).subscribe((data: any) => {
      this.PlantList1 = data.lstPlant;
      const id = data.lstPlant[0].PT_Id;
      this.InputForm.get('UserPlant1')?.patchValue(id);
      this.getProcessOrder()
     // this.getLine(id);
      //this.getItemCode();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getLine(id: any) {
    const key = {
      PT_ID: id,
      userId: 206
    };

    this.productivityservice.getLineData(key).subscribe((data: any) => {
      this.lineList = data.lstLine;
      const lineDefault = this.lineList[0];
      this.InputForm.controls.line.patchValue(lineDefault.PL_Id);
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getUnit(id: number) {
    const key = {
      PL_ID: id,
      userId: 206
    };

    this.productivityservice.getUnitData(key).subscribe((data: any) => {
      this.unitList = data.lstUnit;
      const unitDefault = this.unitList[0];
      if(unitDefault){
        this.InputForm.controls.unit.patchValue(unitDefault.PU_Id);
      }else{
        this.InputForm.controls.unit.patchValue("0");
      }
     
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });

  }

  // getItemCode(): void {
  //   const key = {
  //     EGId: this.InputForm.value.UserGroup1,
  //     PTId: this.InputForm.value.UserPlant1
  //   };
  //   this.batchReportService.getItemCode(key).subscribe((data: any) => {
  //     this.itemList = data.ItemInfoList;
  //     this.filteredItemCodes = this.itemList.slice();
  //     this.InputForm.get('ItemCode')?.patchValue(this.itemList[0].ItemCode);
  //     const id = this.itemList[0].ItemCode;
  //     //this.getProcessOrder(id);
  //   }, (error: any) => {
  //     this.toaster.error('Error', error.message);
  //   });
  // }

  getProcessOrder(): void {
    const key = {
      StartDate: this.InputForm.value.startDate,
      EndDate: this.InputForm.value.endDate,
      PTId :this.InputForm.value.UserPlant1
    };
    this.batchReportService.getProcessOrderByPlant(key).subscribe((data: any) => {
      this.processOrderList = data.masterList;
      this.filteredPOs = this.processOrderList.slice();
      this.processOrderList.length > 0 ? this.InputForm.get('po')?.setValue(this.processOrderList[0].TypeName):this.InputForm.get('po')?.setValue("0");
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  getBatchReport():void {
    const key = {
      PP_Id: this.InputForm.value.po,
    };
    this.batchReportService.getInputReport(key).subscribe((data: any) => {
      this.rowData = data.ProducutionItemBOMList;
     
      this.spinner.hide();
    }, (error: any) => {
      this.toaster.error('Error', error.message);
      this.spinner.hide();
    });
  }

  onClickView(data:any):void{
    this.openPopupViewBatchHistory(data.data);
  }

  openPopupViewBatchHistory(element: any): void {
    this.dialog.open(this.batchViewModal, {
      width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
    })
     this.getBatchItemBOMInfo(element);
  }

  getBatchItemBOMInfo(element : any):void{
    const key = {
      Id : element.JobBatchId
    };
    this.batchReportService.getBatchItemBOMReport(key).subscribe((data: any) => {
      this.batchReportViewDatasource = data.batchItemBOMList;
    }, (error: any) => {
      this.toaster.error('Error', error.message);
    });
  }

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value:string){
    let val;
    if(this.langObj && this.langObj[value]){
      val = this.langObj[value];
    }
    return val?val:value;
 }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId:this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if(this.langObj){
        this.gridApi.refreshHeader();
      }
    });
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.userService.GetBreadcrumList(obj).subscribe((data: any) => {
     this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length -1].id;
      console.log(data.BreadcrumList);
      this.getLangWords();
      this.lang = new Multilingual(this.translater,this.translate);
      this.lang.getLangWords();
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }
  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.enterpriseGroupService.GetMenuAccess(key).subscribe((data: any) => {
      this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
    // return false;
  }
  //===================================================================== AG Grid (TODO : AbdurRazique) =================================================================//
  expand() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = false;
    this.Collapsehide = true;
    this.Isexpandcontentshow = true;
    this.Isexpandcontenthide = false;
    this.Isexpandcontentbuttonshow = true;
  }

  close() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = true;
    this.Collapsehide = false;
    this.Isexpandcontentshow = true;
    this.Isexpandcontenthide = true;
    this.Isexpandcontentbuttonshow = false;
  }
  
  onFirstDataRendered(params: any) {
    setTimeout(function () {
      params.api.getDisplayedRowAtIndex(1)?.setExpanded(true);
    }, 0);
  }
  excelExport() {
    let params: any = {
      allColumns: false,
      skipHeader: false,
      filename :'Input-report'
    }

    params.processCellCallback = function (cellParams: any) {
      if (
        (cellParams && cellParams.column.colId === 'createdOn'))
        return cellParams.value !== null
          ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A')
          : ''
      else return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsExcel(params);
  }
  csvExport(){
    let params: any = {
      allColumns: false,
      skipHeader: false,
      filename :'Input-report'
    }
    params.processCellCallback = function (cellParams: any) {
      if (
        (cellParams && cellParams.column.colId === 'createdOn'))
        return cellParams.value !== null
          ? moment(cellParams.value).format('MM/DD/YYYY HH:mm A')
          : ''
      else return cellParams.value // no formatting
    }
    this.gridApi.exportDataAsCsv(params)
    // var params = {
    //   fileName: 'Input-report',
    // } 
    // this.gridApi.exportDataAsCsv(params);
  }
  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit(); 
  }
  valueFormatter(params: any) {
    return params.value.toFixed(params.colDef.precision);
  }

}
function cell(text:any, styleId:any) {
  return {
    styleId: styleId,
    data: {
      type: /^\d+$/.test(text) ? 'Number' : 'String',
      value: String(text),
    },
  };
}
